import { ApiBase } from "./ApiBase";
import { Collection, CollectionFields, ContentStatus } from "typings";

export class CollectionAPI extends ApiBase
{
    async getCollections(): Promise<Collection[]>
    {
        const response = await this.fetch("frontend/collection");
        return response.json();
    }

    async getCollection(id: string): Promise<Collection>
    {
        const response = await this.fetch(`frontend/collection/${id}`);
        return response.json();
    }

    async changeCollectionName(id: string, name: string): Promise<Collection>
    {
        return this.fetchAsync("POST", `frontend/collection/changeCollectionName/${id}/${name}`);
       
    }

    async updateData(id: string, data: CollectionFields): Promise<Collection>
    {
        return this.fetchAsync("POST", `frontend/collection/${id}/data`, data);
    }

    async setParentId(id: string, parentId?: string): Promise<Collection>
    {
        return this.fetchAsync("POST", `frontend/collection/${id}/parentId`, parentId ? parentId : " ");
    }
    
    async deleteCollection(id: string): Promise<void>
    {
        return this.fetchAsync("DELETE", `frontend/collection/${id}`);
    }

    async updateStatus(id: string, status: ContentStatus): Promise<Collection>
    {
        return this.fetchAsync("POST", `frontend/collection/updateStatus/${id}/${status}`);
    }
}


// WEBPACK FOOTER //
// ./src/services/collection.ts